import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { RouteComponentProps, Prompt } from 'react-router-dom';
import { fetchApi, JsonResponse } from '../../services/api';
import { MaskedTextBox, NumericTextBox } from '@progress/kendo-react-inputs';
import LoadingPanel from '../LoadingPanel';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { IDName } from '../Accounts/Payments';
import CourseAutoComplete, { CourseSearchResult } from '../CourseAutoComplete';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import LoadingButton from '../LoadingButton';
import { CourseEditModal } from './CourseEditModal';
import * as $ from 'jquery';

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    skip: number;
    academic: AcademicData|undefined;
    isLoading: boolean;
    isDirty: boolean;
    childId: number;
    validation: boolean;
    searchCourse: CourseSearchResult|null;
    filter: CompositeFilterDescriptor;

    // For editing courses
    editLink: ApiLink | null;

    // Data for adding courses
    academicYear: string;
    gradeTaken: number;
    courseId: number;
    midtermGrade: number;
    finalGrade: number;
    semesterTaken: number;
    period: number;
    schoolId: number;
    notes: string;
    teachers: IDName[];
    teacherId: number;
}

type AcademicData = {
    Schools: IDName[];
    StudentNumber: string;
    StudentEmail: string;
    MobilePhone: string;
    SchoolId: number;
    Grade: number;
    Courses: CourseData[];
}

type CourseData = {
    StudentCourseId: number;
    TeacherName: string;
    MidtermGrade: number;
    FinalGrade: number;
    CourseName: string;
    CourseCode: string;
    SchoolName: string;
    GradeTaken: number;
    Period: number;
    Semester: string;
    Notes: string;
}

export default class Academic extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            filter: { logic: 'and', filters: [] = [] } as CompositeFilterDescriptor,
            skip: 0,
            childId: 0,
            academic: undefined,
            isLoading: false,
            isDirty: false,
            validation: false,
            searchCourse: null,

            editLink: null,

            // Course Data
            academicYear: "",
            courseId: 0,
            gradeTaken: 0,
            midtermGrade: 0,
            finalGrade: 0,
            semesterTaken: 0,
            period: 0,
            schoolId: 0,
            teachers: [],
            teacherId: 0,
            notes: ""
        }

        this.save = this.save.bind(this);
        this.addCourse = this.addCourse.bind(this);
        this.onChangeSchool = this.onChangeSchool.bind(this);
        this.deleteCourseRecord = this.deleteCourseRecord.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestAcademic(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.academic && this.state.childId != childId) {
            this.requestAcademic(childId);
        }
    }

    public render() {
        const grades = [
            {ID: 0, Name: "Kindergarten"},
            {ID: 1, Name: "1"},
            {ID: 2, Name: "2"},
            {ID: 3, Name: "3"},
            {ID: 4, Name: "4"},
            {ID: 5, Name: "5"},
            {ID: 6, Name: "6"},
            {ID: 7, Name: "7"},
            {ID: 8, Name: "8"},
            {ID: 9, Name: "9"},
            {ID: 10, Name: "10"},
            {ID: 11, Name: "11"},
            {ID: 12, Name: "12"}
        ];
        const years = [
            {ID: 3, Name: "2020-2021"},
            {ID: 2, Name: "2019-2020"},
            {ID: 1, Name: "2018-2019"},
            {ID: 0, Name: "2017-2018"}
        ];
        const semesters = [
            {ID: 0, Name: "Semester One"},
            {ID: 1, Name: "Semester Two"},
            {ID: 2, Name: "Summer"},
            {ID: 3, Name: "Full Year"}
        ];
        const periods = [
            {ID: 1, Name: "First"},
            {ID: 2, Name: "Second"},
            {ID: 3, Name: "Third"},
            {ID: 4, Name: "Fourth"},
            {ID: 5, Name: "Five"},
            {ID: 6, Name: "Six"},
            {ID: 7, Name: "Seven"},
            {ID: 8, Name: "Eight"},
            {ID: 9, Name: "After Hours"}
        ];
        return <div>
            {this.state.editLink && <CourseEditModal
                CloseDialog={() => this.setState({ editLink: null })}
                RefreshSchedule={() => this.requestAcademic(this.state.childId)}
                Link={this.state.editLink} />}
            <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
            {this.state.isLoading && <div className="k-loading-image"></div>}
            {this.state.academic &&
                <form className="k-form">
                    <br />
                    <h5>Academic Information</h5>
                    <div className="card">
                        <div className="card-body">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Student Number<div style={{ color: '#dc3545' }}>*</div></span>
                                </div>
                                <input
                                    className="form-control"
                                    type="text"
                                    name={`StudentNumber`}
                                    placeholder="Student Number"
                                    value={this.state.academic.StudentNumber}
                                    onChange={(e) => this.updateAcademicState({ StudentNumber: e.target.value })}
                                />
                            </div>
                            {this.state.validation && !this.state.academic.StudentNumber && <p className="error-msg">Student Number is Required</p>}
                            <br />
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Student Email</span>
                                </div>
                                <input
                                    className="form-control"
                                    type="text"
                                    name={`StudentEmail`}
                                    placeholder="Student Email"
                                    value={this.state.academic.StudentEmail}
                                    onChange={(e) => this.updateAcademicState({ StudentEmail: e.target.value })}
                                />
                            </div>
                            <br />
                            <label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">Cell Phone</span>
                                    </div>
                                    <MaskedTextBox
                                        className="form-control"
                                        mask="(000)000-0000"
                                        name={`MobilePhone`}
                                        placeholder="(000)000-0000"
                                        value={this.state.academic.MobilePhone || ''}
                                        onChange={(e) => this.updateAcademicState({ MobilePhone: e.target.value.replace(/_/g, "") })}
                                    />
                                </div>
                            </label>
                            <br />
                            <div className="form-group">
                                <label>School</label>
                                <DropDownList
                                    textField="Name"
                                    data={this.state.academic.Schools}
                                    defaultItem={{ID: 0, Name: "None"}}
                                    value={this.state.academic.Schools.find(x => x.ID == this.state.academic.SchoolId)}
                                    onChange={(e) => { this.updateAcademicState({ SchoolId: e.target.value.ID })}}
                                    style={{width: '60%' }}
                                />
                            </div>
                            <div className="form-group">
                                <label>Grade</label>
                                <DropDownList
                                    textField="Name"
                                    data={grades}
                                    value={grades.find(x => x.ID == this.state.academic.Grade)}
                                    onChange={(e) => { this.updateAcademicState({ Grade: e.target.value.ID })}}
                                />
                            </div>
                        </div>
                    </div>
                    <br />
                    <LoadingButton
                        type="button"
                        isLoading={this.state.isLoading}
                        disabled={!this.state.isDirty}
                        className="btn btn-primary"
                        onClick={this.save}
                    >
                        Save
                    </LoadingButton>
                    <br/>
                    <div className="col">
                        <div className="float-right">
                            <button type="button" className="btn btn-success" data-toggle="modal" data-target=".bd-example-modal-lg">Add Course</button>
                            <div className="modal fade bd-example-modal-lg" tabIndex={-1} role="dialog" id="myModal">
                                <div className="modal-dialog modal-lg" role="document">
                                    <div className="modal-content k-form">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Add Course</h5>
                                            <button type="button" className="close ml-0" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="form-group">
                                                <label htmlFor="courseCode">Course Name / Code</label>
                                                <CourseAutoComplete
                                                    className="form-control"
                                                    style={{ color: '#007bff', width: "100%", marginTop: "5px" }}
                                                    callbackFromParent={this.myCourseCallback.bind(this)} />
                                            </div>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">School Taken At</span>
                                                </div>
                                                <DropDownList
                                                    textField="Name"
                                                    className="form-control"
                                                    data={this.state.academic.Schools}
                                                    value={this.state.academic.Schools.find(x => x.ID == this.state.schoolId)}
                                                    onChange={(e) => { this.onChangeSchool(e.target.value.ID) }}
                                                />
                                            </div>
                                            <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">Teacher</span>
                                                </div>
                                                <DropDownList
                                                    textField="Name"
                                                    className="form-control"
                                                    data={this.state.teachers}
                                                    onChange={(e) => { this.setState({ teacherId: e.target.value.ID })}}
                                                />
                                            </div>
                                            <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">Academic Year Taken</span>
                                                </div>
                                                <DropDownList
                                                    textField="Name"
                                                    className="form-control"
                                                    data={years}
                                                    onChange={(e) => { this.setState({ academicYear: e.target.value.Name })}}
                                                />
                                            </div>
                                            <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">Semester Taken</span>
                                                </div>
                                                <DropDownList
                                                    textField="Name"
                                                    className="form-control"
                                                    data={semesters}
                                                    onChange={(e) => { this.setState({ semesterTaken: e.target.value.ID })}}
                                                />
                                            </div>
                                            <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">Period</span>
                                                </div>
                                                <DropDownList
                                                    textField="Name"
                                                    className="form-control"
                                                    data={periods}
                                                    onChange={(e) => { this.setState({ period: e.target.value.ID })}}
                                                />
                                            </div>
                                            <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">Grade Taken</span>
                                                </div>
                                                <DropDownList
                                                    textField="Name"
                                                    className="form-control"
                                                    data={grades}
                                                    onChange={(e) => { this.setState({ gradeTaken: e.target.value.ID })}}
                                                />
                                            </div>
                                            <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">Midterm Grade</span>
                                                </div>
                                                <NumericTextBox
                                                    placeholder="Midterm Grade"
                                                    onChange={(e) => { this.setState({ midtermGrade: e.target.value })}}
                                                    max={100}
                                                    min={0}
                                                    step={1}
                                                />
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">Final Grade</span>
                                                </div>
                                                <NumericTextBox
                                                    placeholder="Final Grade"
                                                    onChange={(e) => { this.setState({ finalGrade: e.target.value })}}
                                                    max={100}
                                                    min={0}
                                                    step={1}
                                                />
                                            </div>
                                            
                                            <div className="input-group" style={{ margin: "5px 0 0 0" }}>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">Notes</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name={`Notes`}
                                                    placeholder="Notes"
                                                    value={this.state.notes}
                                                    onChange={(e) => this.setState({ notes: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button className="btn btn-default mr-auto" data-dismiss="modal">Close</button>
                                            <LoadingButton className="btn btn-success" onClick={this.addCourse} isLoading={this.state.isLoading} type="button">Add Course</LoadingButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h5 style={{ margin: "25px 0 0 0" }}>Course Information</h5>
                    <hr />
                    <div style={{ margin: "5px 0 0 0" }}>
                        {this.state.academic.Courses.map((course, index) => {
                            return (
                                <div className="Card" key={index}>
                                    <div className="row">
                                        <div className="col">
                                            <h5>{course.CourseCode} - {course.CourseName}</h5>
                                            <span><strong>School:</strong> {course.SchoolName}&nbsp;<strong>Teacher</strong>: {course.TeacherName}</span>
                                            <br />
                                            <span><strong>Midterm Grade:</strong> {course.MidtermGrade === 0 ? "N/A" : course.MidtermGrade}&nbsp;<strong>Final Grade:</strong> {course.FinalGrade === 0 ? "N/A" : course.FinalGrade}</span>
                                            <br />
                                            <span><strong>Grade Taken:</strong> {course.GradeTaken === 0 ? "N/A" : course.GradeTaken}&nbsp;<strong>Semester:</strong> {course.Semester}&nbsp;<strong>Period:</strong> {course.Period === 0 ? "N/A" : course.Period}</span>
                                        </div>
                                        <div className="col">
                                            <div className="btn-group float-right" role="group" aria-label="Button group with nested dropdown">
                                                <button type="button" className="btn btn-secondary" onClick={(e) => this.openEdit(e, course.StudentCourseId)}>
                                                    Edit
                                                </button>
                                                <button type="button" className="btn btn-danger" onClick={(e) => {
                                                        e.preventDefault();
                                                        if (confirm("Delete the course record?")) {
                                                            this.deleteCourseRecord(course.StudentCourseId)
                                                        }
                                                    }}>
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                </div>);
                        })}
                    </div>
                    {!this.state.isLoading && this.state.academic.Courses.length === 0 && <h3 style={{ textAlign: 'center' }}>No Courses Defined</h3>}
                    <br />
                    <br />
                </form>
            }
        </div>;
    }

    myCourseCallback = (result: CourseSearchResult) => {
        this.setState({ searchCourse: result });
        if (result)
            this.filterVia('CourseId', result.CourseId);
        else
            this.filterVia('CourseId', null);
    };

    private openEdit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, studentCourseId: number): void {
        e.preventDefault();

        this.setState({ editLink: { Rel: "GetStudentCourse", Method: "GET", Href: `api/Course/Get/${studentCourseId}` }});
    }

    private deleteCourseRecord(studentCourseId: number): void {
        this.setState({ isLoading: true });
        fetchApi(`api/Course/Delete/${studentCourseId}`, {}, 'DELETE')
        .then(() => {
            this.setState({ isLoading: false });
            if (this.state.academic) {
                const Courses = this.state.academic.Courses.filter(x => x.StudentCourseId !== studentCourseId).slice();
                this.updateAcademicState({ Courses });
            }
        });
    }

    private save() {
        if (this.state.academic.StudentNumber === null || this.state.academic.StudentNumber === '')
        {
            alert('Student number is required');
            return;
        }

        const { Schools, Courses, ...data} = this.state.academic;

        this.setState({ isLoading: true });
        fetchApi(`api/ChildAcademic/Save/${this.state.childId}`, data, 'POST')
            .then(() => {
                this.setState({ isDirty: false });
            }).catch((error: Error) => {
                alert("Unknown Error Occurred!");
            }).finally(() => {
                this.setState({ isLoading: false });
            });
    }

    private onChangeSchool(schoolId: number) {
        this.setState({ schoolId: schoolId });
        fetchApi(`api/Teacher/GetTeachersAtSchool/${schoolId}`)
            .then((teachers: IDName[]) => {
                this.setState({ teachers: teachers })
            });
    }

    private addCourse() {
        if (this.state.searchCourse === null)
        {
            alert('A course must be selected.');
            return;
        }

        if (this.state.schoolId === 0)
        {
            alert('Please select a school');
            return;
        }

        if (this.state.teacherId === 0)
        {
            alert('Please select a teacher');
            return;
        }

        const data = {
            AcademicYear: this.state.academicYear,
            GradeTaken: this.state.gradeTaken,
            CourseId: this.state.searchCourse.CourseId,
            MidtermGrade: this.state.midtermGrade,
            FinalGrade: this.state.finalGrade,
            SemesterTaken: this.state.semesterTaken,
            Period: this.state.period,
            SchoolId: this.state.schoolId,
            TeacherId: this.state.teacherId,
            Notes: this.state.notes,
        };

        this.setState({ isLoading: true });
        fetchApi(`api/Course/Add/${this.state.childId}`, data, 'POST')
            .then((response: JsonResponse) => {
                if (response.Success) {
                    $('#myModal').modal('hide');
                    this.requestAcademic(this.state.childId);
                } else {
                    this.setState({ isLoading: false });
                    alert(response.ErrorMessage);
                }
            });
    }

    private requestAcademic(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/ChildAcademic/Get/${childId}`)
            .then((response: { Academic: AcademicData, Teachers: IDName[] }) => {
                this.setState({ isLoading: false, isDirty: false, academic: response.Academic, teachers: response.Teachers });
                // We set this in this way so the modal can preselect and load the teachers dropdown appropriately
                if (response.Academic.SchoolId > 0) {
                    this.setState({ schoolId: response.Academic.Schools.find(x => x.ID == response.Academic.SchoolId).ID });
                }
            });
    }

    private updateAcademicState(value: Object|AcademicData) {
        const academic = Object.assign({}, this.state.academic, value);
        this.setState({ academic, isDirty: true });
    }

    private filterVia(field: string, value: any) {
        let myCompositeFilter: CompositeFilterDescriptor = this.state.filter;

        let myFilterDescriptors = myCompositeFilter.filters as FilterDescriptor[];
        let myFilterDescriptor = myFilterDescriptors.find(x => x.field === field);

        if (myFilterDescriptor) {
            if (value)
                myFilterDescriptor.value = value;
            else
                myFilterDescriptors = myFilterDescriptors.filter(x => x.field !== field);
        } else if (value) {
            myFilterDescriptors.push({ field: field, operator: "eq", value: value });
        }

        myCompositeFilter.filters = myFilterDescriptors;

        this.setState({
            filter: myCompositeFilter,
            skip: 0
        });
    }
}
